﻿$.fn.dxCtrlBuilderEmailStyleDisplayScreen = function custom_dxCtrlBuilderEmailStyleDisplayScreen(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstyledisplayscreen dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleDisplayScreen(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleDisplayScreen = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var ds = [{ id: 1, element: $("<i class='fas fa-mobile-screen'></i>"), text: "Tél.mobile", title: "Afficher le bloc sur téléphone mobile"} ]
        ds.push({ id: 2, element: $("<i class='fas fa-display'></i>"), text: "Tablette/ordinateur",title:"Afficher le bloc sur tablette et ordinateur" })
        var dsSelect = []
        if (!option.element.hasClass("masquemobile")) dsSelect.push(ds[0])
        if (!option.element.hasClass("masquelarge")) dsSelect.push(ds[1])

        $("<div style='max-width:330px;'/>").appendTo(container).dxCtrlRadioButtonMulti({
            label: option.label,
            labelMode: option.labelMode,
            dataSource: ds,
            value: dsSelect,
            itemTemplate: function (itemData, idx, itemElement) {
                itemData.element.appendTo(itemElement)
                $("<span></span>").text(" " + itemData.text).appendTo(itemElement)
            },
            onValueChanged: function (e) {
                if (e.value.filter(function (o) { return o.id == 1 }).length == 0) {
                    option.element.addClass("masquemobile")
                } else {
                    option.element.removeClass("masquemobile")
                }
                if (e.value.filter(function (o) { return o.id == 2 }).length == 0) {
                    option.element.addClass("masquelarge")
                } else {
                    option.element.removeClass("masquelarge")
                }
                option.onValueChanged({})
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}